<template lang="pug">
  md-card.md-card-profile
    md-card-header(data-background-color='green')
      h4.title {{firstName}} {{lastName}}
      p.category Account Overview
    md-card-content
      b UT EID: 
      span {{eid}}
      br
      b Role: 
      span {{role}}
      br
      b Account Type: 
      span {{isPaid ? "Paid Member" : "Free Member"}}
      br
      md-button.md-round.md-success(v-on:click='logOut') Log out
</template>
<script>
import axios from 'axios';
export default {
  name: "user-card",
  props: {
    firstName: String,
    lastName: String,
    role: String,
    eid: String,
    isPaid: Boolean
  },
  data() {
    return {};
  },
  methods: {
    logOut() {
      axios.post('/api/logout')
      .then((response) => {
        this.$store.commit('logout', 'clear');
        this.$router.replace({path: '/'});
      }).catch(() => {
        this.$store.commit('logout', 'clear');
        this.$router.replace({path: '/'})
      })
    }
  }
};
</script>
<style>
  b, span {
    font-size: 120%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/UserManagement/UserCard.vue